<p-dialog
  *ngIf="viewModel$ | async as viewModel"
  header="Schedule Event"
  [modal]="true"
  [visible]="viewModel.bookEventDialogVisible"
  (onHide)="store.dispatch(actions.closeBookDialogButtonClicked())"
  [closable]="false"
  [draggable]="false"
  [styleClass]="'fullscreen-dialog'"
  class="grid jobsv2-{{ colorScheme.colorScheme.value }}"
>
  <ng-template pTemplate="header">
    <h3>
      Book {{ viewModel.eventToBook?.title }} for {{ viewModel.customerName }}
    </h3>
    <div class="header-right">
      <button
        pButton
        class="cancel-button"
        icon="pi pi-times"
        label="Close"
        type="button"
        [outlined]="true"
        [pTooltip]="viewModel.closeButtonDisabledTooltip"
        tooltipPosition="left"
        [disabled]="viewModel.closeButtonDisabled"
        (click)="store.dispatch(actions.closeBookDialogButtonClicked())"
      ></button>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="main-container">
      <div class="schedule-form">
        <ng-container *hasPermission="['jobs.update']">
          <div
            *ngIf="viewModel.scheduleMode === 'schedule'"
            class="event-form-flex"
          >
            <!---------------- DATE ---------------->
            <div>
              <label class="section-label">Date</label>
              <!-- This is also disabled/enabled in the "reset" method -->
              <p-calendar
                class="full-width-calendar"
                [disabled]="viewModel.dateDisabled"
                [ngModel]="viewModel.selectedStartDate"
                (onSelect)="handleDateSelected($event)"
                appendTo="body"
                [minDate]="freyaHelperService.lockDateObject$ | async"
              ></p-calendar>

              <small *ngIf="freyaHelperService.lockDate$ | async"
                >You must schedule events after
                {{ viewModel.formattedLockDate.short }} (Lock Date)</small
              >
            </div>

            <!---------------- START TIME ---------------->
            <div>
              <label class="section-label">Start Time</label>
              <p-dropdown
                class="full-width-dropdown"
                [placeholder]="timePlaceholder"
                [disabled]="false"
                [ngModel]="viewModel.selectedTime"
                [loading]="viewModel.loadingFindTime"
                (onChange)="
                  store.dispatch(
                    actions.timeSelected({
                      time: $event.value,
                    })
                  )
                "
                [options]="viewModel.possibleTimes"
                appendTo="body"
              >
              </p-dropdown>
              <br />
            </div>

            <!---------------- TOTAL DURATION ---------------->
            <div
              *ngIf="viewModel.eventItinerarySummary"
              class="jobsv2-{{ colorScheme.colorScheme.value }}"
            >
              <label class="section-label">
                {{ viewModel.eventItinerarySummary.totalTime }}
              </label>
              <div class="time-pill">
                <div
                  class="labor-time"
                  [style.width.%]="
                    viewModel.eventItinerarySummary.laborTimeWidth
                  "
                  [pTooltip]="viewModel.eventItinerarySummary.totalLocationTime"
                ></div>
                <div
                  class="travel-time"
                  [style.width.%]="
                    viewModel.eventItinerarySummary.travelTimeWidth
                  "
                  [pTooltip]="viewModel.eventItinerarySummary.totalTravelTime"
                ></div>
              </div>
              <div class="duration-labels">
                <span class="labor-label">{{
                  viewModel.eventItinerarySummary.totalLocationTime
                }}</span>
                <span class="travel-label">{{
                  viewModel.eventItinerarySummary.totalTravelTime
                }}</span>
              </div>
            </div>

            <!---------------- DURATION / ITINERARY ---------------->
            <app-event-itinerary></app-event-itinerary>

            <!---------------- ASSETS ---------------->
            <div>
              <label class="section-label">{{
                viewModel.assetTypeNames
              }}</label>
              <p-multiSelect
                #selectAsset
                class="full-width-multiselect"
                placeholder="Select Asset"
                [options]="viewModel.possibleAssets"
                dataKey="id"
                optionLabel="name"
                optionValue="id"
                filterBy="name"
                appendTo="body"
                [disabled]="viewModel.assetsDisabled"
                [autofocusFilter]="!responsiveHelper.isSmallScreen"
                [ngModel]="viewModel.selectedAssets"
                (onChange)="
                  store.dispatch(
                    actions.assetsSelected({
                      assetIds: $event.value,
                    })
                  );
                  selectAsset.hide()
                "
              >
                <ng-template let-asset pTemplate="item">
                  <p>{{ asset.name }}</p>
                </ng-template>
                <ng-template let-assets pTemplate="selectedItems">
                  <p *ngFor="let a of assets">{{ a.name }}</p>
                  <p *ngIf="!assets?.length">
                    Select {{ viewModel.assetTypeNames }}
                  </p>
                </ng-template>
              </p-multiSelect>
            </div>

            <!-- <div class="update-cancel-buttons">
                <button
                  pButton
                  class="full-width quick-margin p-button-text"
                  label="Cancel"
                  icon="pi pi-times"
                  (click)="close()"
                ></button>
                <button
                  pButton
                  class="full-width quick-margin"
                  label="Update Event"
                  icon="pi pi-check"
                  [disabled]="
                    (selectedTime$ | async) === undefined ||
                    (selectedAssets$ | async).length === 0
                  "
                  (click)="updateEventButtonClicked()"
                ></button>
              </div> -->
            <div
              class="action-buttons"
              *ngIf="viewModel.scheduleMode === 'schedule'"
            >
              <ng-container *ngIf="viewModel.eventToBook">
                <button
                  *ngIf="
                    viewModel.eventToBook.status === 'pending' ||
                      viewModel.eventToBook?.status === 'required';
                    else closeButton
                  "
                  pButton
                  [outlined]="true"
                  label="Schedule without booking"
                  icon="pi pi-calendar"
                  pTooltip="Save this event as a draft. You can finalize the booking later."
                  tooltipPosition="left"
                  [disabled]="viewModel.saveAsDraftButtonLoading"
                  (click)="store.dispatch(actions.saveAsButtonClicked())"
                  [loading]="viewModel.saveAsDraftButtonLoading"
                ></button>
                <ng-template #closeButton>
                  <button
                    pButton
                    [outlined]="true"
                    label="Exit Booking"
                    icon="pi pi-sign-out"
                    tooltipPosition="left"
                    [disabled]="viewModel.closeButtonDisabled"
                    (click)="
                      store.dispatch(actions.closeBookDialogButtonClicked())
                    "
                  ></button>
                </ng-template>
              </ng-container>
              <button
                pButton
                class="flex-1"
                [label]="viewModel.alreadyScheduled ? 'Reschedule' : 'Book'"
                [icon]="
                  viewModel.eventBeingScheduled
                    ? 'pi pi-spin pi-spinner'
                    : 'pi pi-check'
                "
                [disabled]="viewModel.bookButtonDisabled"
                (click)="store.dispatch(actions.bookButtonClicked())"
              ></button>
            </div>
          </div>

          <!---------------- VIEW MODE ---------------->
          <div *ngIf="viewModel.scheduleMode === 'view'">
            <div>
              <h4>Date:</h4>
              <span class="freya-link-button">{{
                viewModel.eventToBook?.start
                  | freyaDate: 'MMM d, y' : viewModel.timezone
              }}</span>
              <div class="p-mt-2">
                <app-object-state
                  *ngIf="viewModel.eventToBook?.status === 'cancelled'"
                  [object]="viewModel.eventToBook"
                  objectType="event"
                  [colorful]="true"
                ></app-object-state>
              </div>
            </div>

            <div>
              <h4>Start / End:</h4>
              <p>
                {{
                  viewModel.eventToBook
                    | eventDuration: false : false : true : viewModel.timezone
                }}
              </p>
            </div>
            <div>
              <h4>Start / End (Dock to Dock):</h4>
              <p>
                {{
                  viewModel.eventToBook
                    | eventDuration: true : false : true : viewModel.timezone
                }}
              </p>
            </div>

            <div>
              <h4>Assets:</h4>
              <p *ngFor="let a of viewModel.eventToBook.assets">{{ a.name }}</p>
            </div>

            <div>
              <button
                *hasPermission="['calendarEvents.update']"
                pButton
                class="full-width quick-margin"
                label="Reschedule"
                icon="pi pi-calendar-plus"
                [disabled]="viewModel.eventBeingScheduled"
                (click)="store.dispatch(actions.rescheduleButtonClicked())"
              ></button>
            </div>
          </div>
          <div *ngIf="viewModel.eventToBook?.start">
            <span
              [pTooltip]="
                viewModel.eventToBook?.locked
                  ? 'This event ends before ' +
                    viewModel.formattedLockDate.short
                  : undefined
              "
              tooltipPosition="bottom"
            >
            </span>

            <span
              [pTooltip]="
                viewModel.eventToBook?.locked
                  ? 'This event ends before ' +
                    viewModel.formattedLockDate.short
                  : undefined
              "
              tooltipPosition="bottom"
            >
            </span>
            <div
              *ngIf="
                (viewModel.eventToBook.title === 'Time Lock' &&
                  !viewModel.job?.users?.length) ||
                !viewModel.job?.users?.[0].user
              "
            >
              <p-message
                severity="warn"
                text="Events cannot be booked until a customer has been set"
              ></p-message>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="schedule-container">
        <app-booking-schedule #schedule></app-booking-schedule>
      </div>
      <div></div>
    </div>
  </ng-template>
</p-dialog>
